import styled from 'styled-components';

import { DEFAULT_SIZE, SIZES } from './Base.constants';

const VARIABLES = {
  [SIZES.L]: {
    titleFontSize: '34px',
    titleFontWeight: '700',
    titleLineHeight: '36px',
    containerRowGap: '24px',
    contentRowGap: '24px',
  },
  [SIZES.M]: {
    titleFontSize: '28px',
    titleFontWeight: '600',
    titleLineHeight: '32px',
    containerRowGap: '24px',
    contentRowGap: '24px',
  },
  [SIZES.S]: {
    titleFontSize: '20px',
    titleFontWeight: '500',
    titleLineHeight: '24px',
    containerRowGap: '16px',
    contentRowGap: '8px',
  },
};

const selectVariableValue = (key) => {
  return ({ size = DEFAULT_SIZE }) => {
    return VARIABLES[size][key];
  };
};

export const Container = styled.div`
  --title-font-size: ${selectVariableValue('titleFontSize')};
  --title-font-weight: ${selectVariableValue('titleFontWeight')};
  --title-line-height: ${selectVariableValue('titleLineHeight')};
  --title-color: var(--color-black);

  --description-font-size: 15px;
  --description-font-weight: 400;
  --description-line-height: 20px;
  --description-color: var(--color-grey-11_60);

  --top-column-gap: 8px;
  --top-row-gap: 8px;

  --header-column-gap: 8px;
  --header-row-gap: 8px;

  --container-row-gap: ${selectVariableValue('containerRowGap')};

  --content-row-gap: ${selectVariableValue('contentRowGap')};

  display: flex;
  flex-direction: column;

  row-gap: var(--container-row-gap);
`;

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;

  row-gap: var(--top-row-gap);
`;

export const TopWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: space-between;

  column-gap: var(--top-column-gap);
`;

export const Title = styled.p`
  font-family: var(--main-font-family);
  font-size: var(--title-font-size);
  font-weight: var(--title-font-weight);
  line-height: var(--title-line-height);
  color: var(--title-color);

  margin: 0;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  align-items: center;

  column-gap: var(--header-column-gap);
  row-gap: var(--header-row-gap);
`;

export const Description = styled.p`
  font-family: var(--main-font-family);
  font-size: var(--description-font-size);
  font-weight: var(--description-font-weight);
  line-height: var(--description-line-height);
  color: var(--description-color);

  margin: 0;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  row-gap: var(--content-row-gap);
`;
